import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { BASE_PROJECT_PATH, generateRoutePath } from '@/src/routes';

import { MemberDTO } from '../types';

const url = `${PREFIX_URL}${BASE_PROJECT_PATH}/settings/dashboard`;

export type DashboardMembersResponse = {
  'looker-reports-url': string;
  members: MemberDTO[];
  'reports-enabled': boolean;
};

export const getDashboardMembers = (projectId: number): Promise<DashboardMembersResponse> => {
  const URL = generateRoutePath(url, { projectId });

  return axios.get(URL);
};

export const dashboardMembersKeys = {
  list: (projectId: number) => ['dashboardMembers', projectId] as const,
};

type QueryFnType = typeof getDashboardMembers;

type useDashboardMembers = {
  projectId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useDashboardMembers = ({ projectId, config }: useDashboardMembers) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: dashboardMembersKeys.list(projectId),
    queryFn: () => getDashboardMembers(projectId),
    staleTime: Infinity,
    ...config,
  });
};
